import React, { useEffect, useState } from 'react'; 
 
import styled from 'styled-components';
export default function TaskListNavBar({itemList, onSelect}) {
   

    return (
        <NavBarWrapper>
            {(Array.isArray(itemList))
                ?(itemList.map((navBarItem, index)=>{
                    const widthPercent = 100 / itemList.length;
                    if(navBarItem['currTab'] === true)
                    {
                        return(<BarSelectedItem key={`task-list-nav-bar-item-${index}`} width={widthPercent} onClick={()=>{if(onSelect)onSelect(index)}}>{navBarItem['txt']}</BarSelectedItem>);
                    }
                    else
                    {
                        return(<BarItem  key={`task-list-nav-bar-item-${index}`} width={widthPercent}  onClick={()=>{if(onSelect)onSelect(index)}}>{navBarItem['txt']}</BarItem>);
                    }

                }))
                :null
            }
        </NavBarWrapper>
    );
}
 
export const NavBarWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    background:white; 
    padding: 0 calc(100vw*(7/375));
    border-radius: calc(100vw*(33/375)) calc(100vw*(33/375)) 0px 0px;
    box-shadow: 0px 0px 20px 7px #F6ECCA;
`
export const BarItem = styled.div`
    padding-top : calc(100vw*(18/375));
    padding-bottom : calc(100vw*(15/375));
    width : ${(props)=>{return props['width']+'%'}};
    text-align: center; 
    font-style: normal; 
    font-size: calc(100vw*(16/375)); 
    color: #121212;
`
export const BarSelectedItem = styled(BarItem)`
    font-weight: bold;
    border-bottom : 3px solid #121212;

`